import { useEffect, useState } from 'react';

import http from 'src/services/httpService';
import errorHandler from 'src/utils/error-handler';

const MS_POR_MINUTO = 60 * 1000;

// Busca os dados de NPS + controla refresh manual e auto-refresh.
export default function useDashboardNps(
  entidadeId,
  { enabled = true, filtros, active = true, autoRefreshInicial = 0 } = {}
) {
  const [isLoading, setIsLoading] = useState(false);
  const [dados, setDados] = useState(null);
  const [refreshToken, setRefreshToken] = useState(0);
  const [autoRefreshMinutos, setAutoRefreshMinutos] =
    useState(autoRefreshInicial);

  const refresh = () => setRefreshToken((prev) => prev + 1);

  useEffect(() => {
    if (!enabled || !entidadeId) {
      setDados(null);
      return undefined;
    }

    let ativo = true;

    const carregarDados = async () => {
      setDados(null);
      setIsLoading(true);
      try {
        const response = await http.get(
          '/FormularioGlobalDashboard/ObterDadosNps',
          { params: { entidadeId, ...filtros } }
        );

        if (ativo) {
          setDados(response.data);
        }
      } catch (err) {
        if (ativo) {
          errorHandler(err);
        }
      } finally {
        if (ativo) {
          setIsLoading(false);
        }
      }
    };

    carregarDados();

    return () => {
      ativo = false;
    };
  }, [enabled, entidadeId, filtros, refreshToken]);

  // Auto-refresh: só roda com a view ativa e um intervalo selecionado.
  useEffect(() => {
    if (!enabled || !active || autoRefreshMinutos <= 0) return undefined;

    const intervalId = setInterval(() => {
      setRefreshToken((prev) => prev + 1);
    }, autoRefreshMinutos * MS_POR_MINUTO);

    return () => clearInterval(intervalId);
  }, [enabled, active, autoRefreshMinutos]);

  return {
    isLoading,
    dados,
    refreshToken,
    refresh,
    autoRefreshMinutos,
    setAutoRefreshMinutos,
  };
}
